import React, { Fragment } from "react";
import { useForm } from "react-hook-form";
import { Row, Col, Form, Label, Button } from "reactstrap";
import QRCode from 'react-qr-code';
const QRGenerator = ({ setSteps, setFormdata, formdata,qrcontent }) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const onSubmit = (data) => {
        setFormdata((prev) => ({ ...prev, ...data }));
        setSteps(0);
    };
    return (
        <Fragment>
            <Row>
                <Col sm="12">
                    <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
                        <div className="dflex">
                            <Col md="12 mb-3">
                                {qrcontent && (
                                    <QRCode value={qrcontent} size={200} bgColor={'#FFFFFF'} fgColor={'#000000'}/>
                                )}
                            </Col>

                            <div className="text-end btn-mb">
                                <Button className="primary">Finalizar</Button>
                            </div>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Fragment>
    );
};

export default QRGenerator;
